import * as React from 'react';
import LuxonDatePicker from "./LuxonDatePicker";
import {DateTime} from "luxon";
import {PickerTimeProps} from "antd/es/time-picker";


export interface LuxonTimePickerProps extends Omit<PickerTimeProps<DateTime>, 'picker'> {}

const LuxonTimePicker = React.forwardRef<any, LuxonTimePickerProps>((props, ref) => (
  <LuxonDatePicker {...props} picker="time" mode={undefined} ref={ref} />
));

LuxonTimePicker.displayName = 'LuxonTimePicker';

export default LuxonTimePicker;
